import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { UploadAction } from "./upload-action";
import { UploadConfiguration } from "./upload-configuration";

@JsonObject()
export class UploadRequestWrapper {
    @JsonProperty("file_name")
    fileName: string;

    @JsonProperty("file_size")
    fileSize: number;

    @JsonProperty("upload_configuration")
    @JsonElementType(UploadConfiguration)
    uploadConfiguration: UploadConfiguration;

    @JsonProperty("action")
    @JsonElementType(UploadAction)
    action: UploadAction;
}
